<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.7802 2.46967C10.4873 2.17678 10.0124 2.17678 9.71952 2.46967L5.85089 6.3383C5.84469 6.3445 5.83851 6.35068 5.83234 6.35684C5.65026 6.5389 5.48304 6.7061 5.35467 6.85731C5.21628 7.02033 5.07959 7.21339 4.99971 7.45922C4.88551 7.8107 4.88551 8.1893 4.99971 8.54078C5.07959 8.78661 5.21628 8.97967 5.35467 9.14269C5.48304 9.2939 5.65027 9.46111 5.83235 9.64316L5.85089 9.6617L9.71952 13.5303C10.0124 13.8232 10.4873 13.8232 10.7802 13.5303C11.0731 13.2374 11.0731 12.7626 10.7802 12.4697L6.91155 8.60104C6.70479 8.39428 6.58203 8.27069 6.49818 8.17193C6.44701 8.11165 6.42959 8.08222 6.42526 8.07399C6.41033 8.02579 6.41033 7.9742 6.42526 7.92601C6.42959 7.91778 6.44701 7.88835 6.49818 7.82807C6.58203 7.72931 6.70479 7.60572 6.91155 7.39896L10.7802 3.53033C11.0731 3.23744 11.0731 2.76256 10.7802 2.46967Z"
    fill="currentColor"
  />
</svg>
